import { User } from 'shared/types/user'

export interface SetPasswordRequest {
  password: string
  repeat_password: string
  token: string
}

export interface SetPasswordResponse {
  message: string
  data: User
}
